export const muiButtonBaseOverrides = {
  root: {
    "&.Mui-disabled": {
      cursor: "not-allowed",
      pointerEvents: "all",
    },
  },
};
